import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { filtroEstadosProveedor } from "../../helper/ordenHelper";
import { fetchSellers, fetchProveedoresFilter } from '../../actions/sellersActions';
import { DropDownArrow, customStyle } from "../../template/CustomStyle";
import { limpiarFiltros } from '../../actions/generalActios';
import { filtroMedioMes } from '../../utilities/fechasFiltro';
import { setFiltroOrdenes } from '../../actions/ordenesActions';
const fechaFiltro = filtroMedioMes();

class FiltroOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: "",
            idUsuario: this.props.userType.isProveedor ? this.props.idUsuario : "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            entidadOrdenamiento: 1,
            proveedor: { label: "", value: "" },
            codProv: this.props.userType.isProveedor ?
                (this.props.codProv ? this.props.codProv : "") : "",
            estado: { label: "", value: "" },
            estadoOblea: "",
            proveedores: []
        }
    };

    componentDidMount() {
        this.setState(this.setFiltrosDesdeProps());
        this.props.fetchProveedoresFilter({ descripcion: "" });
    }

    componentDidUpdate(prevProps) {
        if (this.props.filtro !== prevProps.filtro) {
            this.setState(this.setFiltrosDesdeProps());
        }
    }

    setFiltrosDesdeProps() {
        const { filtro, codProv, idUsuario, userType } = this.props;

        return {
            fechaDesde: filtro.fechaDesde !== undefined ? filtro.fechaDesde : fechaFiltro.desde,
            fechaHasta: filtro.fechaHasta !== undefined ? filtro.fechaHasta : fechaFiltro.hasta,
            codProv: codProv !== undefined ? codProv : (userType.isProveedor && this.props.codProv ? this.props.codProv : ""),
            idUsuario: userType.isProveedor ? idUsuario : "",
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: filtro.idOrden !== undefined ? filtro.idOrden : "",
            proveedor: {
                label: filtro.proveedor !== undefined ? filtro.proveedor.label : "",
                value: filtro.proveedor !== undefined ? filtro.proveedor.value : ""
            },
            estado: {
                label: filtro.estado !== undefined ? filtro.estado.label : "",
                value: filtro.estado !== undefined ? filtro.estado.value : ""
            },
            documento: filtro.documento,
            nombre: filtro.nombre,
            apellido: filtro.apellido,
        };
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.props.setFiltroOrdenes({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.props.limpiarFiltros({
            publicaciones: true,
            ordenes: false,
            proveedores: false,
        });

        this.props.updateRequest(this.state);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
        if (config.name === "estado") {
            this.setState({ estadoOblea: options.value });
        }
        if (config.name === "proveedor") {
            this.setState({ codProv: options.value });
        }
    }

    onSelectSearchInputProveedores = (descripcion) => {
        this.props.fetchProveedoresFilter({ descripcion });
    }

    verTodos = () => {
        this.setState({
            idOrden: "",
            codProv: "",
            estadoOblea: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta
        });

        let params = {
            idOrden: "",
            codProv: "",
            estadoOblea: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            cantidadPagina: 10,
            numeroPagina: 1,
            entidadOrdenamiento: 1
        }

        this.props.updateRequest(params);
    }

    mapProveedores = () => {
        let opcionTodos = { value: "", label: "Todos" };
        this.props.proveedores.unshift(opcionTodos);
    }

    render() {
        const { idOrden, proveedor, estado, documento, apellido, fechaDesde, fechaHasta } = this.state;
        let listaProveedor = [];
        if (this.props.proveedores != undefined) {
            this.props.proveedores.map((item) => {
                listaProveedor.push({ label: item.label, value: item.value.toString() })
            })
        }

        return (

            <div className="card shadow-sm border-0 rounded mb-4">
                <div className="card-header bg-white border-0 pt-4 pb-0">
                    <h5 className="mb-0 font-weight-bold text-dark">Filtros de Búsqueda</h5>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">N° Orden</label>
                            <input
                                type="number"
                                name="idOrden"
                                className="form-control"
                                placeholder="Ej: 12345"
                                value={idOrden == null ? "" : idOrden}
                                onChange={this.myChangeHandler}
                                min={0}
                            />
                        </div>

                        {(this.props.idTipoUsuario === 1 || this.props.idTipoUsuario === 2) && (
                            <div className="col-lg-3 col-md-6 mb-3">
                                <label className="form-label text-muted small fw-bold">Proveedores</label>
                                <Select
                                    name="proveedor"
                                    value={proveedor}
                                    options={listaProveedor}
                                    onChange={this.selectSearchHandler}
                                    onMenuOpen={this.mapProveedores}
                                    onInputChange={this.onSelectSearchInputProveedores}
                                    components={{ DropdownIndicator: () => DropDownArrow }}
                                    styles={customStyle}
                                    placeholder="Seleccione..."
                                />
                            </div>
                        )}

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">Estados</label>
                            <Select
                                name="estado"
                                value={estado}
                                options={filtroEstadosProveedor}
                                onChange={this.selectSearchHandler}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                                placeholder="Seleccione..."
                            />
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">DNI</label>
                            <input
                                type="number"
                                name="documento"
                                className="form-control"
                                placeholder=""
                                value={documento == null ? "" : documento}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">Apellido</label>
                            <input
                                type="text"
                                name="apellido"
                                className="form-control"
                                placeholder=""
                                value={apellido == null ? "" : apellido}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">Fecha desde</label>
                            <input
                                type="date"
                                name="fechaDesde"
                                className="form-control"
                                value={fechaDesde}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                        <div className="col-lg-3 col-md-6 mb-3">
                            <label className="form-label text-muted small fw-bold">Fecha hasta</label>
                            <input
                                type="date"
                                name="fechaHasta"
                                className="form-control"
                                value={fechaHasta}
                                onChange={this.myChangeHandler}
                            />
                        </div>

                    </div>

                    <hr className="my-4 op-5" />

                    <div className="row">
                        <div className="col-12 text-end">
                            <button onClick={this.verTodos} className="btn btn-outline-secondary me-2">
                                Limpiar Filtros
                            </button>
                            <button
                                className="btn btn-danger px-4"
                                onClick={this.onSubmit}
                                type="button"
                                disabled={this.props.loadingOrdenes}
                            >
                                {this.props.loadingOrdenes ? 'Buscando...' : 'Buscar'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    sellers: state.sellers.filteredSellers,
    estados: state.ordenes.estados,
    idUsuario: state.general.userId,
    proveedores: state.sellers.filteredProveedores,
    filtro: state.ordenes.filtro,
    filtro: state.ordenes.filtro,
    codProv: state.general.codProv,
    idTipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, {
    fetchSellers,
    fetchProveedoresFilter,
    limpiarFiltros,
    setFiltroOrdenes
})(FiltroOrdenes);